module.exports = __webpack_public_path__ + "img/20210823_124113.8885ec10.jpg";